<template>
	<label
		class="form-check form-switch form-check-custom form-check-solid fw-bold mb-5">
		<span v-if="!block_computer">Bloquear computador</span>
		<span v-else>Desbloquear computador</span>
		<input
			v-model="block_computer"
			id="check-config-computer"
			class="form-check-input ms-2"
			type="checkbox" />
	</label>

	<hardware_selection :computer_uid="props.computer_uid" />

	<div class="row mt-5">
		<div class="col-12 mt-2 mt-md-0">
			<loading_button
				:loading="scan_loading"
				:action="scanComputer"
				color="info">
				Realizar scan no computador
			</loading_button>
		</div>
	</div>
</template>

<script setup lang="ts">
	import axios from 'axios';
	import { ref, watch } from 'vue';
	import hardware_selection from './hardware_selection.vue';
	import loading_button from '../Widgets/loading_button.vue';

	const props = defineProps({
		computer_uid: { type: String, required: true },
		find_agent_url: { type: String, required: true },
		block_computer_url: { type: String, required: true },
		scan_computer_url: { type: String, required: true },
	});

	const block_computer = ref(false);
	const scan_loading = ref(false);

	async function scanComputer() {
		scan_loading.value = true;

		axios
			.post(props.scan_computer_url, {
				uid: props.computer_uid,
			})
			.then((response) => {
				//@ts-ignore
				toastr.success(
					'Scan realizado ! A página será atualizada para trazer as informações do computador.'
				);
				setTimeout(() => window.location.reload(), 3000);
			})
			.catch((response) => {
				const error = JSON.parse(response.request.response).message;
				//@ts-ignore
				toastr.error(
					'Ocorreu um erro ao realizar o scan no computador. Erro: ' +
						error
				);
			})
			.finally(() => (scan_loading.value = false));
	}

	function showBlockComputerDialog(computer_blocked) {
		//@ts-ignore
		Swal.fire({
			title: computer_blocked ? 'Bloquear' : 'Desbloquear',
			text: computer_blocked
				? 'Você tem certeza que deseja bloquear o computador ?'
				: 'Você tem certeza que deseja desbloquear o computador ?',
			type: 'alert',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Sim',
			cancelButtonText: 'Não',
		}).then((result) => {
			if (result.value) {
				//@ts-ignore
				Swal.fire({
					title: 'Aguarde o processo ser finalizado',
					type: 'success',
					showConfirmButton: false,
					timer: 0,
					allowOutsideClick: false,
					allowEscapeKey: false,
					allowEnterKey: false,
				});
				change_computer_status(computer_blocked);
			} else {
				//@ts-ignore
				Swal.fire({
					icon: 'error',
					title: 'Cancelado...',
					text: 'Nenhuma alteração foi feita',
				});
				setTimeout(() => {
					window.location.reload();
				}, 1000);
			}
		});
	}

	function change_computer_status(computer_blocked) {
		axios
			.post(props.block_computer_url, {
				uid: props.computer_uid,
				status: computer_blocked ? 'maintenance' : 'exam',
			})
			.then((result) => {
				//@ts-ignore
				Swal.fire({
					title: 'Atualizado com sucesso.',
					type: 'alert',
				}).then(() => {
					window.location.reload();
				});
			})
			.catch((result) => {
				//@ts-ignore
				Swal.fire({
					title: 'Ocorreu um erro.',
					type: 'alert',
					text: result.response.data.message,
				}).then(() => {
					window.location.reload();
				});
			});
	}

	watch(block_computer, (newValue) => {
		showBlockComputerDialog(newValue);
	});
</script>
